<div *ngIf="!video?.source?.video_spaces_original" class="d-flex align-items-center justify-content-center">
  <img 
    [src]="isRecent(video?.created_at) 
             ? 'assets/img/courses/video_upload.png' 
             : 'assets/img/courses/video_not_found.png'" 
    alt="Imagen centrada" 
    class="img-fluid" 
    style="height: 400px" 
  />
</div>

<div class="video-spaces" *ngIf="this.video?.source?.exist&&this.video?.source?.video_spaces_original">
  <vg-player *ngIf="safeUrl" (onPlayerReady)="onPlayerReady($event)">
    <vg-overlay-play></vg-overlay-play>
    <vg-buffering></vg-buffering>  
    <vg-controls *ngIf="vgControl">
      <vg-play-pause></vg-play-pause>  
      <vg-time-display vgProperty="current" [vgFormat]="timeFormat"></vg-time-display>
      <vg-scrub-bar>
        <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
      </vg-scrub-bar>
      <vg-time-display vgProperty="total" [vgFormat]="timeFormat"></vg-time-display>

      <vg-track-selector *ngIf="subtitles.length"></vg-track-selector>
      <vg-mute></vg-mute>
      <vg-volume></vg-volume>
      <vg-fullscreen></vg-fullscreen>
    </vg-controls>


        <!-- El video debe ir primero -->
        <video id="my-video" #media [vgMedia]="$any(media)" preload="auto" [attr.autoplay]="autoPlay ? true : null" [poster]="video?.thumb_url" crossorigin>
          <source [src]="safeUrl" type="video/mp4">
          <track *ngFor="let subtitle of subtitles"
            kind="subtitles"
            [attr.src]="subtitle.url"
            [attr.srclang]="subtitle.language"
            [attr.label]="subtitleLabel(subtitle.language)"
            [attr.default]="isDefaultSubtitle(subtitle.language) ? '' : null">
        </video>
    
  </vg-player>

  





</div>

<!-- <div *ngIf="!this.video?.source?.exist" class="d-flex align-items-center justify-content-center">
  <img src="assets/img/courses/video_not_found.png" alt="Imagen centrada" class="img-fluid" style="height: 400px" />
</div> -->

<ng-container *ngIf="isMicroclip">
  <div class="row justify-content-center">
    <div class="col-auto">
      <button id="setStartBtn" (click)="setIntervalPoint('start')" class="btn btn-primary my-3 mx-5">
        {{ "Set microclip start" }}
      </button>
      <input [(ngModel)]="selectedInterval.start" class="input-number form-control" id="clip-title" name="name"
        placeholder="{{
          'admin:users:modal:discountProfile:label:2:placeholder' | translate
        }}" type="number" />
    </div>
    <div class="col-auto">
      <button id="setEndBtn" (click)="setIntervalPoint('end')" class="btn btn-primary my-3 mx-5">
        {{ "Set microclip end" }}
      </button>
      <input [(ngModel)]="selectedInterval.end" class="input-number form-control" id="clip-title" name="name"
        placeholder="{{
          'admin:users:modal:discountProfile:label:2:placeholder' | translate
        }}" type="number" />
    </div>
  </div>
  <div class="row text-center my-2">
    <div id="selectedInterval">
      {{ "Selected interval: " | translate }}
      {{ this.selectedInterval.start.toFixed(2) }}s -
      {{ this.selectedInterval.end.toFixed(2) }}s
    </div>
  </div>
</ng-container>